<app-modal-container
  [bigSize]="true"
  [title]="'New period'"
  [buttons]="{ close: true }"
  (closeButtonClicked)="close(null)">

  <div class="flex flex-col items-start gap-y-[1rem] !w-[20rem]" [formGroup]="modalCopyPeriodFormService.form">
    <app-selector
      data-qa="modal-copy-period-old-period"
      class="!w-full"
      formControlName="initialPeriod"
      [isNotInTable]="true"
      [title]="'Copied period'"
      [data]="periods"
    />
    <app-formated-date-input
      data-qa="modal-copy-period-new-period"
      class="!w-full"
      formControlName="newPeriod"
      [title]="'New period date'"
      [dateFormat]="YYYY_MM_DD"
      [additionalClass]="newPeriod.additionalClass"
      [bottomText]="newPeriod.bottomText"
    />
    <div class="flex items-center gap-[0.25rem]" (click)="updateExpensesChecked()">
      <app-checkbox
        data-qa="update-expenses"
        [checked]="isUpdatingExpenses"
        (checkBoxClicked)="updateExpensesChecked()"
      />
      <span class="font-3 font-medium">Update expenses prediction</span>
    </div>
    <app-button
      data-qa="modal-copy-period-continue-button"
      class="w-full"
      [additionalClasses]="'w-full'"
      [bordersSquaredShape]="'full'"
      [type]="'accent'"
      [disabled]="!modalCopyPeriodFormService.form.valid"
      (buttonClick)="confirmCopyingRoundByFundIdAndPeriod()">
        Continue
    </app-button>
  </div>
</app-modal-container>
